import type { RecommendedProductAdmin } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { Button } from '@/shared/ui';

interface RecommendedProductRowProps {
  readonly product: RecommendedProductAdmin;
  /** 1부터 시작하는 노출 순번. */
  readonly order: number;
  readonly isFirst: boolean;
  readonly isLast: boolean;
  readonly isBusy: boolean;
  readonly onMove: (direction: 'UP' | 'DOWN') => void;
  readonly onRemove: () => void;
}

/** 추천 상품 한 행 — 순번, 썸네일, 상품명, 위·아래, 제외. 1번은 HOME 히어로 카드에 나온다. */
export const RecommendedProductRow = ({
  product,
  order,
  isFirst,
  isLast,
  isBusy,
  onMove,
  onRemove,
}: RecommendedProductRowProps): ReactElement => (
  <li className="flex flex-wrap items-center gap-3 rounded-lg border p-3">
    <span className="w-6 text-center text-sm font-semibold tabular-nums">{order}</span>
    {product.thumbnail !== null ? (
      <img
        src={product.thumbnail.url}
        alt=""
        width={40}
        height={40}
        className="size-10 rounded object-cover"
      />
    ) : (
      <span aria-hidden className="size-10 rounded bg-muted" />
    )}
    <span className="flex min-w-0 flex-1 items-center gap-2">
      <span className="truncate font-medium">{product.name}</span>
      {order === 1 ? (
        <span className="shrink-0 rounded-full bg-muted px-2 py-0.5 text-xs">히어로 카드</span>
      ) : null}
    </span>
    <span className="flex items-center gap-1">
      <Button
        size="sm"
        variant="outline"
        disabled={isFirst || isBusy}
        onClick={() => onMove('UP')}
        aria-label={`${order}번 추천 상품 위로`}
      >
        위로
      </Button>
      <Button
        size="sm"
        variant="outline"
        disabled={isLast || isBusy}
        onClick={() => onMove('DOWN')}
        aria-label={`${order}번 추천 상품 아래로`}
      >
        아래로
      </Button>
      <Button
        size="sm"
        variant="ghost"
        disabled={isBusy}
        onClick={onRemove}
        aria-label={`${order}번 추천 상품 제외`}
      >
        제외
      </Button>
    </span>
  </li>
);
